import { CertStatus } from 'data/certStatus/certStatus.types';

export const exportCertsCSV = (certStatuses: CertStatus[]) => {
  if (!certStatuses || certStatuses.length === 0) {
    console.warn('No data to export');
    return;
  }

  const csvHeaders = [
    'ID',
    'CERTID',
    'AFTYPE',
    'LITYPE',
    'COMMONNAME',
    'EXPIREDATE',
    'STATUS',
    'KEYALGORITHM',
    'DIGEST',
    'SERIALNUMBER',
  ];

  const csvRows = certStatuses.map((cert) => [
    cert.id,
    cert.CERTID ?? '',
    cert.AFTYPE,
    cert.LITYPE,
    cert.COMMONNAME,
    cert.EXPIREDATE ?? '',
    cert.STATUS,
    cert.KEYALGORITHM,
    cert.DIGEST,
    cert.SERIALNUMBER,
  ]);

  const csvContent = [
    csvHeaders.join(','), // Add headers
    ...csvRows.map((row) => row.map((value) => `"${value}"`).join(',')), // Format rows
  ].join('\n');

  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);

  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', `certificates_${new Date().toISOString()}.csv`);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};

export default exportCertsCSV;
